import classNames from 'classnames';
import I18n from '../../../config/i18n';
import Format from '../../../utils/Formatter';

import './MatchingPrice.css';

interface MatchingPriceProps {
  priceInfo: {
    price: number;
    arrival: moment.Moment | string;
    departure: moment.Moment | string;
  };
  loading: boolean;
}

export default function MatchingPrice({ priceInfo, loading }: MatchingPriceProps): JSX.Element {
  return (
    <div className={classNames('price matching-price', { loading })}>
      <div className="matching-price-duration">
        {Format.dateMonthShort(priceInfo.arrival)}–{Format.dateMonthShort(priceInfo.departure)}
      </div>
      <span className="price-value matching-price-value">
        {I18n.l('currency', priceInfo.price)}
      </span>
    </div>
  );
}
